// extracted by mini-css-extract-plugin
export default {"categoryChips":"categoryChips__jUmC3","searchChip":"searchChip___Qa9q","selected":"selected__Whe6p"};